module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 1
// module chunks = 0